<template>
  <div>
    <b-table
      :items="items"
      :fields="fields"
      sort-by="email"
      responsive
      small
      hover
      striped
      show-empty
      :per-page="paging.pageSize"
      :current-page="paging.pageNo"
      :filter="filter"
    >
      <template #cell(createdDate)="data">
        <span>{{ data.item.createdDate | date }}</span>
      </template>

      <template #cell(lastLoginDate)="data">
        <span>{{ data.item.lastLoginDate | dateTime }}</span>
      </template>

      <template #cell(action)="data">
        <div v-if="data.item.userCode !== currentUser.userCode">
          <b-button title="Reset Password" variant="info" size="sm" @click.stop="$emit('reset-password', data.item.userCode)">
            <feather-icon icon="KeyIcon"></feather-icon>
          </b-button>
          <edit-button class="ml-1" @click.stop="$emit('edit', data.item.userCode)"></edit-button>
          <delete-button
            class="ml-1"
            :content="data.item.isActive ? `Deactivate` : `Activate`"
            :variant="data.item.isActive ? `danger` : `success`"
            icon="PowerIcon"
            @click.stop="$emit('toggle-active', data.item)"
          >
          </delete-button>
          <delete-button v-if="!data.item.isActive" class="ml-1"></delete-button>
        </div>
        <div v-else>
          <edit-button class="ml-1" @click.stop="$emit('edit', data.item.userCode)"></edit-button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'AdminView',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    currentUser: {
      type: Object,
      required: true,
    },
    paging: {
      type: Object,
      required: true,
      default: () => ({
        pageNo: 1,
        pageSize: 20,
      }),
    },
    filter: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      fields: [
        { key: `email`, label: `Email`, sortable: true },
        { key: `roleDesc`, label: `Role`, class: `text-nowrap`, sortable: true },
        { key: `createdDate`, label: `Created`, class: `text-right text-nowrap` },
        { key: `lastLoginDate`, label: `Last Login`, sortable: true, class: `text-right text-nowrap` },
        { key: `action`, label: `Action`, class: `text-right action-column` },
      ],
    };
  },
};
</script>
